import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  HostListener,
  OnInit,
  Output,
  Renderer2
} from '@angular/core';

import { PickedFile } from './picked-file';
import { PickedFileImpl } from './picked-file-impl';
import { ReadMode } from './read-mode.enum';
export class FilePickerDirective implements OnInit {
public accept = '';
/**
 * @return {?}
 */
get multiple() { return this._multiple; }
/**
 * @param {?} value
 * @return {?}
 */
set multiple(value: any) { this._multiple = coerceBooleanProperty(value); }

   readMode: ReadMode;
public filePick = new EventEmitter<PickedFile>();
public readStart = new EventEmitter<number>();
public readEnd = new EventEmitter<number>();
private _multiple: boolean;
private input: any;
/**
 * @param {?} el
 * @param {?} renderer
 */
constructor(private el: ElementRef,
private renderer: Renderer2) {
  }
/**
 * @return {?}
 */
public ngOnInit() {
    this.input = this.renderer.createElement('input');
    this.renderer.appendChild(this.el.nativeElement, this.input);

    this.renderer.setAttribute(this.input, 'type', 'file');
    this.renderer.setAttribute(this.input, 'accept', this.accept);
    this.renderer.setStyle(this.input, 'display', 'none');

    if (this.multiple) {
      this.renderer.setAttribute(this.input, 'multiple', 'multiple');
    }

    this.renderer.listen(this.input, 'change', (event: any) => {
      const /** @type {?} */ fileCount = event.target.files.length;

      this.readStart.emit(event.target.files.length);
      Promise.all(Array.from<File>(event.target.files).map(file => this.readFile(file)))
        .then(() => this.readEnd.emit(fileCount));
    });
  }
/**
 * @return {?}
 */
public reset() {
    if (!this.input) {
      console.error('It seems that ngOnInit() has not been executed or that the hidden input element is null. Did you mess with the DOM?');
      return;
    }

    this.input.value = null;
  }
/**
 * @return {?}
 */
private browse() {
    if (!this.input) {
      console.error('It seems that ngOnInit() has not been executed or that the hidden input element is null. Did you mess with the DOM?');
      return;
    }

    this.input.click();
  }
/**
 * @param {?} file
 * @return {?}
 */
private readFile(file: File): Promise<void> {
    return new Promise((resolve, reject) => {
      const /** @type {?} */ reader = new FileReader();

      reader.onload = (loaded: ProgressEvent) => {
        const /** @type {?} */ fileReader = /** @type {?} */(( loaded.target as FileReader));
        const /** @type {?} */ pickedFile = new PickedFileImpl(file.lastModifiedDate, file.name, file.size, file.type, this.readMode, fileReader.result);

        this.filePick.emit(pickedFile);
        resolve();
      };

      switch (this.readMode) {
        case ReadMode.arrayBuffer:
          reader.readAsArrayBuffer(file);
          break;
        case ReadMode.binaryString:
          reader.readAsBinaryString(file);
          break;
        case ReadMode.text:
          reader.readAsText(file);
          break;
        case ReadMode.dataURL:
        default:
          reader.readAsDataURL(file);
          break;
      }
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[ngFilePicker]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'accept': [{ type: Input },],
'multiple': [{ type: Input },],
'readMode': [{ type: Input, args: ['ngFilePicker', ] },],
'filePick': [{ type: Output },],
'readStart': [{ type: Output },],
'readEnd': [{ type: Output },],
'browse': [{ type: HostListener, args: ['click', ] },],
};
}

function FilePickerDirective_tsickle_Closure_declarations() {
/** @type {?} */
FilePickerDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FilePickerDirective.ctorParameters;
/** @type {?} */
FilePickerDirective.propDecorators;
/** @type {?} */
FilePickerDirective.prototype.accept;
/** @type {?} */
FilePickerDirective.prototype.readMode;
/** @type {?} */
FilePickerDirective.prototype.filePick;
/** @type {?} */
FilePickerDirective.prototype.readStart;
/** @type {?} */
FilePickerDirective.prototype.readEnd;
/** @type {?} */
FilePickerDirective.prototype._multiple;
/** @type {?} */
FilePickerDirective.prototype.input;
/** @type {?} */
FilePickerDirective.prototype.el;
/** @type {?} */
FilePickerDirective.prototype.renderer;
}

/**
 * @param {?} value
 * @return {?}
 */
function coerceBooleanProperty(value: any): boolean {
  return value != null && `${value}` !== 'false';
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
